<template>
  <SectionGroup v-if="content._type === 'sectionGroup'" :heading="content.heading">
    <component
      v-for="bodySection in bodySections || []"
      :is="bodySection.component"
      :key="bodySection.content._key"
      :content="bodySection.content"
    />
  </SectionGroup>
  <component v-else
    :is="bodySectionComponent"
    :content="content"
  />
</template>

<script setup>

import SectionGroup from './SectionGroup.vue'

import AppPromoModule from './AppPromoModule.vue'
import BasicContentSection from './BasicContentSection/index.vue'
import BillboardSection from './BillboardSection.vue'
import CardCarousel from './CardCarousel/index.vue'
import CaseStudyCallout from './CaseStudyCallout.vue'
import CaseStudyCarousel from './CaseStudyCarousel.vue'
import CenteredIframe from './CenteredIframe.vue'
import CollapsibleFeatureListing from './CollapsibleFeatureListing/index.vue'
import ColorfulGrid from './ColorfulGrid.vue'
import ContentSectionWithFeatureCards from './ContentSectionWithFeatureCards/index.vue'
import ContentSectionWithHotspotGraphic from './ContentSectionWithHotspotGraphic.vue'
import ContentSectionWithProductCards from './ContentSectionWithProductCards/index.vue'
import FaqSection from './FaqSection.vue'
import FeatureGrid from './FeatureGrid/index.vue'
import FeatureOverview from './FeatureOverview.vue'
import FinePrint from './FinePrint.vue'
import GatedContentDownloadModule from './GatedContentDownloadModule/index.vue'
import IconStripModule from './IconStripModule.vue'
import ImageBreakoutSection from './ImageBreakoutSection.vue'
import ImagePromoBanner from './ImagePromoBanner.vue'
import InPageForm from './InPageForm/index.vue'
import InsightCarousel from './InsightCarousel/index.vue'
import LogoGridModule from './LogoGridModule.vue'
import LogoStripModule from './LogoStripModule.vue'
import MarketingHighlights from './MarketingHighlights.vue'
import MinorSections from './MinorSections.vue'
import PlaceholderSection from './PlaceholderSection.vue'
import ProductCards from './ProductCards/index.vue'
import ProductDocumentation from './ProductDocumentation.vue'
import ProductFeatureCards from './ProductFeatureCards/index.vue'
import ProductFeatures from './ProductFeatures/index.vue'
import ProductImageGallery from './ProductImageGallery.vue'
import ProductHowToBuy from './ProductHowToBuy.vue'
import QuizModuleSection from './QuizModuleSection.vue'
import QuoteCallout from './QuoteCallout.vue'
import QuoteCalloutWithBackgroundImage from './QuoteCalloutWithBackgroundImage.vue'
import ResourceDownloads from './ResourceDownloads/index.vue'
import ReviewRatingModule from './ReviewRatingModule.vue'
import StandoutContentSection from './StandoutContentSection.vue'
import StandoutFeatureGrid from './StandoutFeatureGrid.vue'
import TabbedImageContentSection from './TabbedImageContentSection/index.vue'
import TestimonialVideoCarousel from './TestimonialVideoCarousel/index.vue'
import TextContentSection from './TextContentSection.vue'
import VideoCarousel from './VideoCarousel/index.vue'

const bodySectionComponentsForType = {
  'appPromoModule': AppPromoModule,
  'billboard': BillboardSection,
  'cardCarousel': CardCarousel,
  'caseStudyCallout': CaseStudyCallout,
  'caseStudyCarousel': CaseStudyCarousel,
  'centeredIframe': CenteredIframe,
  'collapsibleFeatureListing': CollapsibleFeatureListing,
  'contentSectionWithFeatureCards': ContentSectionWithFeatureCards,
  'contentSectionWithHotspotGraphic': ContentSectionWithHotspotGraphic,
  'contentSectionWithProductCards': ContentSectionWithProductCards,
  'colorfulGrid': ColorfulGrid,
  'faqSection': FaqSection,
  'featureGrid': FeatureGrid,
  'featureOverview': FeatureOverview,
  'finePrint': FinePrint,
  'gatedContentDownloadModule': GatedContentDownloadModule,
  'iconStrip': IconStripModule,
  'imageBreakoutSection': ImageBreakoutSection,
  'imagePromoBanner': ImagePromoBanner,
  'inPageForm': InPageForm,
  'insightCarousel': InsightCarousel,
  'logoGrid': LogoGridModule,
  'logoStrip': LogoStripModule,
  'marketingHighlights': MarketingHighlights,
  'minorSections': MinorSections,
  'polymorphicSection': BasicContentSection,
  'productCards': ProductCards,
  'productDocumentation': ProductDocumentation,
  'productFeatureCards': ProductFeatureCards,
  'productFeatures': ProductFeatures,
  'productHowToBuy': ProductHowToBuy,
  'productImageGallery': ProductImageGallery,
  'quizModule': QuizModuleSection,
  'quoteCallout': QuoteCallout,
  'quoteCalloutWithBackgroundImage': QuoteCalloutWithBackgroundImage,
  'resourceDownloads': ResourceDownloads,
  'reviewRating': ReviewRatingModule,
  'standoutContentSection': StandoutContentSection,
  'standoutFeatureGrid': StandoutFeatureGrid,
  'tabbedImageContentSection': TabbedImageContentSection,
  'textContentSection': TextContentSection,
  'testimonialVideoCarousel': TestimonialVideoCarousel,
  'videoCarousel': VideoCarousel,
}



const { content } = defineProps({
  content: Object,
})

const bodySections = (content.bodySections ?? []).map(
  (content) => ({
    content,
    component: bodySectionComponentsForType[content._type] || PlaceholderSection,
  })
)

const bodySectionComponent = bodySectionComponentsForType[content._type] || PlaceholderSection
</script>
